<template>
  <div class="dynamic-by-source-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <div class="chart-am5" ref="chartdiv"></div>

    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { BarChartDynamic } from "../../../../../../../../components/charts";

  // mixins
  import dynamicBySource from "../../../../../../../../mixins/chart/dynamicBySource";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import source from "../../../../../../../../config/source";

  // moment
  import moment from 'moment';

  // vuex
  import { mapGetters } from "vuex";

  import * as am5 from '@amcharts/amcharts5';
  import * as am5xy from '@amcharts/amcharts5/xy';
  import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

  export default {
    name: "PublicationsBySourceBody",
    props: {
      data: {
        type: Object,
        required: true
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      chartName: {
        type: String
      },
      title: {
        type: String
      },
      chartScaleItems: {
        type: Object
      },
      showChartScale: {
        type: Boolean
      }
    },
    data() {
      return {
        source: source,
        chartId: "DynamicBySource",
        format: "DD.MM.YYYY",
        showLabel: true,
        renderCount: 0
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },

    renderChart() {
        let root = am5.Root.new(this.$refs.chartdiv);

        root.setThemes([am5themes_Animated.new(root)]);

        let chart = root.container.children.push(
          am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            wheelX: "panX",
            wheelY: "zoomX",
            layout: root.verticalLayout
          })
        );

        chart.set("colors", am5.ColorSet.new(root, {
          colors: [
            am5.color("#6fd267"),
            am5.color("#4b70b2"),
            am5.color("#4ba4f5"),
            am5.color("#ff9139"),
            am5.color("#f23920"),
            am5.color("#5e6d82"),
            am5.color("#96caff")
          ]
        }))


        // Define data
        let data = this.dataBarCollection.databylables
        console.log("dsdsds", this.data)
        console.log("SSSSSSSs", this.dataBarCollection)
        

        // Create Y-axis
        let yAxis = chart.yAxes.push(
          am5xy.ValueAxis.new(root, {
            renderer: am5xy.AxisRendererY.new(root, {}),
          })
        );

        // Create X-Axis
        let xAxis = chart.xAxes.push(
          am5xy.CategoryAxis.new(root, {
            renderer: am5xy.AxisRendererX.new(root, {}),
            categoryField: "category",
          })
        );
        xAxis.data.setAll(data);

function createSeries(field, name) {
  var series = chart.series.push(am5xy.ColumnSeries.new(root, {
    name: name,
    xAxis: xAxis,
    yAxis: yAxis,
    valueYField: field,
    categoryXField: "category",
    //sequencedInterpolation: true,
    /*tooltip: am5.Tooltip.new(root, {
      pointerOrientation: "vertical",
      labelText: "[bold]{categoryX}[/]\n{name}: {valueY}"
    })*/
  }));

  series.columns.template.setAll({
    height: am5.p100,
    strokeOpacity: 0,
    tooltipText: "[bold]{categoryX}[/]\n{name}: {valueY}",
    width: am5.percent(90),
    tooltipY: 0
  });


  series.bullets.push(function () {
    return am5.Bullet.new(root, {
      locationX: 0.5,
      locationY: 1,
      sprite: am5.Label.new(root, {
        centerX: am5.p50,
        centerY: am5.p100,
        text: "{valueY}",
        populateText: true
      })
    });
  });

  series.bullets.push(function () {
    return am5.Bullet.new(root, {
      locationX: 1,
      locationY: 0.5,
    });
  });

  series.data.setAll(data);
  series.appear();

  return series;
}

        createSeries("gs", "СМИ");
        createSeries("vk", "Вконтакте");
        createSeries("tg", "Telegram");
        createSeries("ok", "Одноклассники");
        createSeries("yt", "Youtube");
        createSeries("fb", "Facebook");
        createSeries("ig", "Instagram");
        createSeries("tw", "Twitter");
        createSeries("dz", "Блоги");


        // Add legend
        let legend = chart.children.push(am5.Legend.new(root, {}));
        legend.data.setAll(chart.series.values);

        // Add cursor
        chart.set("cursor", am5xy.XYCursor.new(root, {}));

        this.root = root;
      },
    },

    watch: {
      data: {
        handler(val, oldVal) {
          console.log('1')
          if(!!this.root) this.root.dispose()
          this.renderChart();
          console.log('11')
        },
        deep: true
      },
    },
    updated() {
      this.renderCount++;
      console.log('Updated ' + this.renderCount + ' times.')
    
  },
    computed: {
      ...mapGetters([
        "socialList",
      ]),
      chartDate() {
        return this.$store.getters.getPeriod(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
      isLoaded() {
        return this.$store.getters.isLoaded(this.chartName);
      }
    },
    mixins: [
      dynamicBySource,
      saveImage
    ],
    components: {
      BarChartDynamic
    },
    mounted() {

      //if(!!this.root) this.root.dispose()
      console.log('0', this.data)
      //this.renderChart()
    },
    beforeMount() {
      console.log('0', this.data)
        console.log('00')
    },
    beforeDestroy() {
        this.root.dispose();
    }
  };
</script>

<style>
  @import "../../../../../../../../style/social.css";

  .chart-am5 {
  width: 100%;
  height: 500px;
}

  .dynamic-by-source-content__chart {
    margin-bottom: 10px;
  }
  .chart-show-labels {
    display: flex;
    justify-content: start;
    padding: 20px 10px;
    font-size: 16px;
  }
  @media screen and (max-width: 480px) {
    .dynamic-by-source-content__chart {
      width: 90vw;
    }
  }
</style>
